import { render, staticRenderFns } from "./return-register.vue?vue&type=template&id=042c7bd2&scoped=true&"
import script from "./return-register.vue?vue&type=script&lang=js&"
export * from "./return-register.vue?vue&type=script&lang=js&"
import style0 from "./return-register.vue?vue&type=style&index=0&id=042c7bd2&lang=scss&scoped=true&"
import style1 from "./return-register.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c7bd2",
  null
  
)

export default component.exports